/* SpellCheck Status Styles */

.statusIcon {
    width: 12px;
    height: 12px;
    border-radius: 50%;
}

.statusIconSuccess {
    background-color: var(--mantine-color-teal-6);
}

.statusIconError {
    background-color: var(--mantine-color-yellow-6);
}

.statusIconIssue {
    background-color: var(--mantine-color-red-6);
}

/* Suggestions card — outer container (dark mode default) */
.suggestionsCard {
    background-color: var(--mantine-color-dark-5);
    border-radius: var(--mantine-radius-md);
    padding: 3px;
    margin: var(--mantine-spacing-xs) var(--mantine-spacing-md);
}
/* Light mode overrides */
[data-mantine-color-scheme="light"] .suggestionsCard {
    background-color: var(--mantine-color-gray-1);
}

.issueHeader {
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
    margin-bottom: 2px;
}
[data-mantine-color-scheme="light"] .issueHeader {
    color: var(--mantine-color-red-7);
}

/* Inner text area — contains text + buttons */
.correctedTextArea {
    background-color: var(--mantine-color-dark-6);
    border-radius: var(--mantine-radius-md);
    padding: 8px var(--mantine-spacing-md);
}

[data-mantine-color-scheme="light"] .correctedTextArea {
    background-color: var(--mantine-color-gray-0);
}

.actionsInside {
    margin-top: 6px;
    padding-top: 4px;
}

.correctedText {
    font-size: var(--mantine-font-size-sm);
    line-height: 1.6;
    color: var(--mantine-color-text);
}

/* Highlighted text showing corrections */
.highlighted {
    text-decoration: underline;
    text-decoration-color: var(--mantine-color-teal-5);
    text-underline-offset: 3px;
}

.cancelButton {
    color: var(--mantine-color-dimmed);
    font-size: var(--mantine-font-size-sm);

    &:hover {
        color: var(--mantine-color-text);
        text-decoration: underline;
    }
}

.sendWithChangesButton {
    background-color: var(--mantine-color-asurion-6);
    font-size: var(--mantine-font-size-sm);

    &:hover {
        background-color: var(--mantine-color-asurion-7);
    }
}
